import { createFileRoute } from "@tanstack/react-router";
import {
  CityDigitalMarketingPage,
  cityDigitalMarketingHead,
} from "@/components/CityDigitalMarketingPage";
import { industryLinksFor } from "@/lib/cityIndustryLinks";

export const Route = createFileRoute("/castle-rock-digital-marketing")({
  headers: () => ({
    "Cache-Control": "public, max-age=0, s-maxage=604800, stale-while-revalidate=2592000",
    "CDN-Cache-Control": "public, s-maxage=604800, stale-while-revalidate=2592000",
  }),
  head: () => cityDigitalMarketingHead("Castle Rock", "castle-rock"),
  component: () => (
    <CityDigitalMarketingPage
      city="Castle Rock"
      slug="castle-rock"
      intro="Castle Rock is one of Colorado's fastest-growing communities — and one of the most competitive markets for local service businesses. We help Castle Rock companies dominate Google, the Map Pack, and AI search results from our Colorado Springs HQ just up I-25."
      whyUs={[
        "We know the I-25 corridor between Colorado Springs and Denver — Castle Rock is in our backyard",
        "Hyper-local SEO targeting The Meadows, Founders Village, Castle Pines, and surrounding neighborhoods",
        "Owner-led strategy from Chris — not a Denver agency that treats Castle Rock as an afterthought",
      ]}
      nearby={[
        { name: "Parker", to: "/parker-digital-marketing" },
        { name: "Colorado Springs", to: "/colorado-springs" },
        { name: "Denver", to: "/denver-digital-marketing" },
        { name: "Aurora", to: "/aurora-digital-marketing" },
        { name: "Monument", to: "/monument-seo" },
      ]}
      testimonial={{
        quote:
          "Chris built our website and SEO from scratch and we're booking jobs from Castle Rock and Parker every single week now.",
        role: "Home Services Owner",
        city: "Castle Rock",
      }}
      industryLinks={industryLinksFor("Castle Rock")}
    />
  ),
});
